import {applyMiddleware, createStore, compose} from 'redux';
import thunkMiddleware from 'redux-thunk';
import {routerMiddleware} from 'connected-react-router';
import rootReducer from './reducers/index';

export default function configureStore(history) {
  const middlewares = [thunkMiddleware, routerMiddleware(history)];
  const middlewareEnhancers = applyMiddleware(...middlewares);
  const enhancers = [middlewareEnhancers];
  const composedEnhancers = compose(...enhancers);
  const store = createStore(rootReducer, composedEnhancers);

  return store;
}
